import CodeService from '@/services/CodeService';
import MainHeader from '@/components/MainHeader.vue';
import SettingsSaveBar from '@/components/SettingsSaveBar.vue';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import IntegrationRequiredModal from '@/components/modals/IntegrationRequiredModal.vue';
import ExpenseTemplateModal from '@/modules/settings/shared/ExpenseTemplateModal.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  name: 'SharedExpense',
  props: {
    codeService: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    },
    http: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: true
    }
  },
  components: {
    ExpenseTemplateModal,
    IntegrationRequiredModal,
    LlSecondaryButton,
    MainHeader,
    SettingsSaveBar
  },
  data() {
    return {
      me: undefined,
      ledes: undefined,
      codes: {
        expense: []
      },
      isProcessing: false,
      openExpenseTemplate: false,
      editExpenseTemplate: false,
      addExpenseTemplate: false,
      editingExpenseTemplate: {},
      editingTemplateId: null,
      form: {},
      unsaved: false
    };
  },
  async mounted() {
    await this.initializeData();
  },
  watch: {
    me() {
      this.resetForm();
    }
  },
  computed: {
    canAddNewEmptyExpense() {
      const hasEmpty = this.form.expenses.find(r => r.label?.trim() === '' || r.amount === '' || r.description?.trim() === '');
      return !hasEmpty;
    },
    somethingChanged() {
      const originalExpense = this.me.company.settings.expenses?.standard?.map(e => ({
        amount: e.amount,
        description: e.description,
        label: e.label,
        saved: true,
        code: e.code?.id
      })) || [];
      return JSON.stringify(this.form.expenses) !== JSON.stringify(originalExpense);
    }
  },
  methods: {
    async initializeData() {
      this.me = await this.userService.getMe();
      this.ledes = this.me.company.settings.codes?.ledes;
      const codeService = new CodeService(this.leanLawApi, this.http, this.leanLawAuth);
      this.codes.expense = await codeService.expenseCodes();
      this.resetForm();
    },
    resetForm() {
      this.form = {
        expenses: this.me.company.settings.expenses?.standard?.sort((a, b) => {
          const valueA = a.label || a.description;
          const valueB = b.label || b.description;
          return valueA?.localeCompare(valueB);
        }).map(o => {
          let item = {
            amount: o.amount,
            description: o.description,
            label: o.label,
            saved: true
          };
          if (o.accounting) {
            item['accounting'] = {
              service: o.accounting.service
            };
          }
          if (this.ledes) {
            item['code'] = {
              id: o.code?.id,
              label: this.codes.expense.find(s => s.value === o.code?.id)?.label
            };
          }

          // accum.push(item);
          return item;
        }, []) || []
      };
      this.assignCodeLabel();
    },
    addNewEmptyExpense() {
      this.openExpenseTemplate = true;
      this.addExpenseTemplate = true;
      this.editExpenseTemplate = false;
    },
    assignCodeLabel() {
      if (!this.ledes) return this.form.expenses;
      return this.form.expenses.map(o => ({
        amount: o.amount,
        description: o.description,
        label: o.label,
        code: {
          id: o.code,
          label: this.codes.expense.find(s => s.value === o.code)?.label
        },
        saved: true
      }));
    },
    updatedTemplate() {
      this.openExpenseTemplate = false;
      this.editExpenseTemplate = false;
      this.addExpenseTemplate = false;
      this.editingExpenseTemplate = {};
      this.editingTemplateId = null;
    },
    updateExpenseTemplate(rate, id) {
      this.openExpenseTemplate = true;
      this.editExpenseTemplate = true;
      this.addExpenseTemplate = false;
      this.editingExpenseTemplate = rate;
      this.editingTemplateId = id;
    },
    async deleteExpenseTemplate(id) {
      this.openExpenseTemplate = false;
      this.form.expenses.splice(id, 1);
      const companyStore = useCompanyStore();
      await companyStore.updateMyCompany({
        settings: {
          expenses: {
            standard: this.form.expenses
          }
        }
      });
    },
    closeModal() {
      this.openExpenseTemplate = false;
      this.addExpenseTemplate = false;
      this.editExpenseTemplate = false;
      this.editingExpenseTemplate = {};
      this.editingTemplateId = null;
    }
  }
};